import { http } from "../util/http";
import { toFormData } from "../util/FormData";
import Util from "../util";

export default class WordService {
  static paginate(filters) {
    return http.get(`/qnas/data-entry/qnas/?${Util.toQuery(filters)}`);
  }

  static paginateTranslations(filters) {
    return http.get(
      `/dictionary/data-entry/translated-word/?${Util.toQuery(filters)}`
    );
  }

  static search(filters) {
    return http.get(`/qnas/data-entry/qnas/?${Util.toQuery(filters)}`);
  }

  static getNextPage(next) {
    return http.get(`/qnas/data-entry/qnas/?${next}`);
  }

  static get(id) {
    return http.get(`/qnas/data-entry/qnas/${id}/`);
  }

  static getTranslation(id) {
    return http.get(`/dictionary/data-entry/translated-word/${id}/`);
  }

  static add(data) {
  
      return http.post(
        "/dictionary/data-entry/words/",
        toFormData(data, { brackets: false })
      );

   
  }

  static addTranslation(word, data) {
    return http.post(
      `/dictionary/data-entry/translated-word/`,
      toFormData({ word, ...data })
    );
  }

  static update(id, data) {
    return http.patch(`/qnas/data-entry/qnas/${id}/`, toFormData(data));
  }

  static updateTranslation(id, data) {
    return http.patch(
      `dictionary/data-entry/translated-word/${id}/`,
      toFormData(data)
    );
  }

  static delete(id) {
    return http.delete(`/qnas/data-entry/qnas/${id}/`);
  }

  static clone(id) {
    return http.post(`/qnas/data-entry/qnas/${id}/clone/`);
  }

  static deleteTranslation(id) {
    return http.delete(`/dictionary/data-entry/translated-word/${id}/`);
  }

  static bulkUpload(file) {
    return http.post(
      "/dictionary/populate/",
      toFormData({ uploaded_file: file })
    );
  }
  static addTags(data) {
      return http.post(
        "/dictionary/data-entry/words/",
        toFormData(data, { brackets: false })
      );
 
  }
  static updateTags(id, data) {
    return http.patch(`/dictionary/data-entry/words/${id}/`, toFormData(data));
  }
}
